module.exports = __webpack_public_path__ + "img/fant_pack.54e71487.png";